/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
// THIS CODE IS GENERATED - DO NOT MODIFY.
const u = undefined;
export default [[["o półn.", "w poł.", "rano", "przed poł.", "po poł.", "wiecz.", "w nocy"], ["o północy", "w południe", "rano", "przed południem", "po południu", "wieczorem", "w nocy"], u], [["półn.", "poł.", "rano", "przedpoł.", "popoł.", "wiecz.", "noc"], ["północ", "południe", "rano", "przedpołudnie", "popołudnie", "wieczór", "noc"], u], ["00:00", "12:00", ["06:00", "10:00"], ["10:00", "12:00"], ["12:00", "18:00"], ["18:00", "21:00"], ["21:00", "06:00"]]];
